import { Field, useFormikContext } from 'formik';

import { MainCategoryOption, SubCategoryOption } from '../../config/absence';
import { FormErrorUI, FormLabelUI, DatePickerUI, AutoCompleteSelectUI, SelectUI } from '../Interface';
import { EmployeeAbsenceApprovalStatusOption } from '../../config/employeeAbsenceRequest';

const EmployeeAbsenceFields = ({ disabled, selectedValues, autoCompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="date"
          name="startDate"
          component={DatePickerUI}
          value={values.startDate}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });
          }}
          disabled={disabled}
          InputLabelProps={{ shrink: values.startDate !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="date"
          name="endDate"
          component={DatePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Befejező dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });
          }}
          disabled={disabled}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="employeeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Dolgozó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.employeeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('employeeId', newVal?.value ?? null).then(() => {
              validateField('employeeId');
            });
          }}
          disabled={disabled}
          InputLabelProps={{ shrink: values.employeeId !== '' }}
          selectedValue={values.employeeId}
          selectedLabelValue={selectedValues?.employee?.name}
          dataset={autoCompleteOptions.employee}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="approverId"
          component={AutoCompleteSelectUI}
          options={autoCompleteOptions.user}
          label={<FormLabelUI text="Engedélyező" />}
          helperText={<FormErrorUI message={errors.approverId} />}
          selectedValue={values.approverId}
          selectedLabelValue={selectedValues?.approverId?.nickName}
          onChange={(_e, newVal) => {
            setFieldValue('approverId', newVal?.value ?? null).then(() => {
              validateField('approverId');
            });
          }}
          disabled={disabled || !!selectedValues.id}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="approvalStatus"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Státusz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.approvalStatus} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('approvalStatus', value ?? null).then(() => {
              validateField('approvalStatus');
            });
          }}
          value={values.approvalStatus ?? ''}
          disabled={disabled}
          option={EmployeeAbsenceApprovalStatusOption}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="mainCategory"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Főkategória" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.mainCategory} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('mainCategory', value ?? null).then(() => {
              validateField('mainCategory');
              setFieldValue('subCategory', null);
            });
          }}
          value={values.mainCategory ?? ''}
          disabled={disabled}
          option={MainCategoryOption}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="subCategory"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Alkategória" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.subCategory} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('subCategory', value ?? null).then(() => {
              validateField('subCategory');
            });
          }}
          value={values.subCategory ?? ''}
          disabled={disabled}
          option={SubCategoryOption[values.mainCategory] || []}
        />
      </div>
    </div>
  );
};

export default EmployeeAbsenceFields;
